import { Card, CardContent, Typography, Checkbox} from "@mui/material";
import { useEffect, useState } from "react";
import { DashboardSummaryRow } from "../../types/DashboardSummaryRow";


type DashboardSummaryCardProps = {

    checked: boolean;
    disabled: boolean;
    onItemDeselected( item: string ): void;
    onItemSelected( item: string ): void;
    row: DashboardSummaryRow;

};


export const DashboardSummaryCard: React.FC<DashboardSummaryCardProps> = ( props: DashboardSummaryCardProps ) => {

    const { checked, disabled, onItemDeselected, onItemSelected, row } = props;

    const [ isSelected, setIsSelected ] = useState< boolean >( false );


    const cardSx = {

        "&:hover": {
            boxShadow: 3,
            transition: 'transform .3s cubic-bezier(.2,.9,.3,1.3)',
            transform: 'scale(1.04)'
          },
        cursor: 'pointer',
        minWidth: '100px',
        backgroundColor: isSelected ? '#EDEDED' : 'none',
    
    };

    useEffect( ( ) => setIsSelected( checked ), [ checked ] );


    const handleCardClick = () => {

        if( row.count === 0 || disabled ) {

            return;

        }

        
        if( isSelected ){

            onItemDeselected( row.item );
            

        } else {

            onItemSelected( row.item );

        }
        
        
        setIsSelected( checked => !checked );


    };


    return(

        <Card key={row.item} sx={cardSx} onClick={ handleCardClick }> 
            <CardContent sx={{ paddingLeft: '3px', paddingRight: '3px' }}>  
                {row.headerText ? ( 
                    <>
                        <Typography sx={{ lineHeight: '40px', display: 'flex', fontWeight: 'bold', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid lightgray' }} >
                            <Checkbox sx={{padding:'0px'}} checked={ isSelected } disabled={ row.count === 0 || disabled } />                   
                            {row.headerText}   
                        </Typography>
                        <Typography sx={{ lineHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid lightgray' }} >
                            {row.text}
                            {row.icon}
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography sx={{ lineHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid lightgray' }} >
                            <Checkbox sx={{padding:'0px'}} checked={ isSelected } disabled={ row.count === 0 || disabled } />                   
                            {row.text}
                            {row.icon}
                        </Typography>                       
                    </>                           
                )}                
                <Typography align="center">
                {row.count}
                </Typography>
            </CardContent>
        </Card>

    );

};